



























import { Component, Watch } from 'vue-property-decorator';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PageNames from '@/router/PageNames';
import Region from '@/models/Settings/Regions/Region';
import RegionCreate from '@/components/Settings/Regions/RegionCreate.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'Regions', components: { Alert, RegionCreate }, metaInfo: { title: 'Regions' } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    headers = [
        { text: this.$t('pageText.regions.fields.name'), sortable: false, width: '40%' },
        { text: this.$t('pageText.regions.fields.timezone'), sortable: false, width: '40%'},
        { text: this.$t('pageText.regions.fields.default'), sortable: false, width: '20%' }
    ];
    regionsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.regionsPage = +page;
        }
    }

    async beforeMount() {
        await RegionsModule.getRegions(this.regionsPage);
    }

    get regions() {
        return RegionsModule.regions;
    }

    get totalRegionsPages() {
        return RegionsModule.totalRegionsPages;
    }

    get loading() {
        return RegionsModule.loading;
    }

    get pageSize() {
        return RegionsModule.pageSize;
    }

    @Watch('regionsPage')
    async onRegionsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.regionsPage}` } });
        // Get new regions
        await RegionsModule.getRegions(this.regionsPage);
    }

    async navigateToRegion(region: Region) {
        this.$router.push({ name: PageNames.Region, params: { id: region.id }, query: { tab: "0" } });
    }

}
